// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { DefaultButton, Stack, Text } from '@fluentui/react';
import { useLocation } from 'react-router-dom';

type TopNavProps = {
  label?: string;
  basePath?: string;
  isAuthenticated?: boolean;
  isAdmin?: boolean;
};

const getBasePath = (pathname: string): string => (pathname.startsWith('/app/v2') ? '/app/v2' : '/app/v1');

const TopNav = ({ label = '', basePath, isAuthenticated = true, isAdmin = false }: TopNavProps): JSX.Element => {
  const location = useLocation();
  const rootPath = basePath ?? getBasePath(location.pathname);

  return (
    <Stack horizontal horizontalAlign="space-between" verticalAlign="center" styles={{ root: { paddingTop: 16 } }}>
      <Text variant="large">{label}</Text>
      <Stack horizontal tokens={{ childrenGap: 8 }}>
        <DefaultButton onClick={() => (window.location.href = rootPath)}>Home</DefaultButton>
        {isAdmin && (
          <>
            <DefaultButton onClick={() => (window.location.href = `${rootPath}/admin`)}>Admin</DefaultButton>
            <DefaultButton onClick={() => (window.location.href = `${rootPath}/roles`)}>Roles</DefaultButton>
          </>
        )}
        <DefaultButton onClick={() => (window.location.href = `${rootPath}/interview`)}>Interview</DefaultButton>
        {isAuthenticated && (
          <DefaultButton onClick={() => (window.location.href = `${rootPath}/logout`)}>Logout</DefaultButton>
        )}
        {!isAuthenticated && (
          <DefaultButton onClick={() => (window.location.href = `${rootPath}/login`)}>Login</DefaultButton>
        )}
      </Stack>
    </Stack>
  );
};

export default TopNav;
